/* unplugin-vue-components disabled */import script from "./DeductPrizeCountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeductPrizeCountModal.vue?vue&type=script&setup=true&lang=js"

import "./DeductPrizeCountModal.vue?vue&type=style&index=0&id=ad35ea90&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad35ea90"]])

export default __exports__